import React from 'react';
import { useConfig } from '../../contexts/ConfigContext';
import { formatDate } from '../../utils/formatters';

const Dashboard: React.FC = () => {
  const { config } = useConfig();
  
  // In a real implementation, these would be fetched from Firebase Analytics
  const analyticsData = {
    visitors: {
      total: 1245,
      today: 87,
      lastWeek: 542
    },
    subscribers: {
      total: 328,
      conversionRate: 26.3,
      lastWeek: 42
    },
    topCountries: [
      { name: 'United States', count: 456 },
      { name: 'United Kingdom', count: 213 },
      { name: 'Canada', count: 187 },
      { name: 'Australia', count: 124 },
      { name: 'Germany', count: 98 }
    ],
    topReferrers: [
      { name: 'Direct', count: 523 },
      { name: 'Google', count: 312 },
      { name: 'Twitter', count: 145 },
      { name: 'Facebook', count: 98 },
      { name: 'Instagram', count: 76 }
    ]
  };
  
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Dashboard Overview</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Visitors</h3>
          <p className="text-3xl font-bold">{analyticsData.visitors.total.toLocaleString()}</p>
          <div className="mt-2 text-sm text-gray-500">
            <p>Today: {analyticsData.visitors.today}</p>
            <p>Last 7 days: {analyticsData.visitors.lastWeek}</p>
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Subscribers</h3>
          <p className="text-3xl font-bold">{analyticsData.subscribers.total.toLocaleString()}</p>
          <div className="mt-2 text-sm text-gray-500">
            <p>Conversion rate: {analyticsData.subscribers.conversionRate}%</p>
            <p>Last 7 days: {analyticsData.subscribers.lastWeek}</p>
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Site Status</h3>
          <p className="text-xl font-medium">
            {config.lastUpdated ? 'Active' : 'Using Default Config'}
          </p>
          <div className="mt-2 text-sm text-gray-500">
            <p>Last updated: {config.lastUpdated ? formatDate(config.lastUpdated) : 'Never'}</p>
            <p>Updated by: {config.updatedBy || 'N/A'}</p>
          </div>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Top Countries</h3>
          <div className="space-y-3">
            {analyticsData.topCountries.map((country, index) => (
              <div key={index} className="flex justify-between items-center">
                <span>{country.name}</span>
                <span className="font-medium">{country.count}</span>
              </div>
            ))}
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Top Referrers</h3>
          <div className="space-y-3">
            {analyticsData.topReferrers.map((referrer, index) => (
              <div key={index} className="flex justify-between items-center">
                <span>{referrer.name}</span>
                <span className="font-medium">{referrer.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="mt-8 bg-blue-50 p-6 rounded-lg border border-blue-200">
        <h3 className="text-lg font-medium text-blue-800 mb-2">Quick Tips</h3>
        <ul className="list-disc list-inside space-y-2 text-blue-700">
          <li>Update your site configuration to customize the landing page</li>
          <li>Adjust the Vanta Birds settings for a unique visual experience</li>
          <li>Send regular communications to keep subscribers engaged</li>
          <li>Export subscriber data for backup or external marketing</li>
        </ul>
      </div>
    </div>
  );
};

export default Dashboard;